import wujiFetch from '@utils/wujiFetch';
import { designPath, getRuntimeEnvPath } from '@config/constant';

const TIMEOUT = 3000;

// 编辑时接口（默认，用于开发工作台的 MCP Key 管理页面）
const baseUrl = `${designPath}/mcp-key`;

// 运行时接口（仅用于"权限和密钥"弹窗）
const getMcpKeyRuntimeBaseUrl = env => `${getRuntimeEnvPath(env)}/mcp-key`;

/**
 * 编辑时：获取 MCP Key 列表
 * GET {designPath}/mcp-key
 */
const listMcpKey = async (projectId, { size, include, sort, order, filter = '' }) => await wujiFetch(baseUrl, {
  method: 'GET',
  timeout: TIMEOUT,
  query: {
    projectid: projectId,
    size,
    include,
    sort,
    order,
    filter,
  },
});

/**
 * 编辑时：创建 MCP Key
 * POST {designPath}/mcp-key
 */
const createMcpKey = async ({ projectId, data = {}, headers = {} }) => await wujiFetch(
  `${baseUrl}?projectid=${projectId}`,
  {
    method: 'POST',
    timeout: TIMEOUT,
    body: JSON.stringify({
      ...data,
      projectId,
    }),
    headers,
  },
);

/**
 * 编辑时：删除 MCP Key
 * DELETE {designPath}/mcp-key/{mcpKey}
 */
const deleteMcpKey = async ({ projectId, mcpKey, headers = {} }) => await wujiFetch(
  `${baseUrl}/${mcpKey}?projectid=${projectId}`,
  {
    method: 'DELETE',
    timeout: TIMEOUT,
    headers,
  },
);

/**
 * 编辑时：更新 MCP Key
 * PATCH {designPath}/mcp-key/{mcpKey}
 */
const updateMcpKey = async ({ projectId, mcpKey, data = {}, headers = {} }) => await wujiFetch(
  `${baseUrl}/${mcpKey}?projectid=${projectId}`,
  {
    method: 'PATCH',
    timeout: TIMEOUT,
    body: JSON.stringify({
      ...data,
      projectId,
    }),
    headers,
  },
);

/**
 * 运行时：获取 MCP Key 列表（"权限和密钥"弹窗使用）
 * GET /api/xy/runtime/env/{env}/mcp-key
 */
const listMcpKeyRuntime = async (projectId, env, { size, include, sort, order, filter = '' }) => await wujiFetch(
  getMcpKeyRuntimeBaseUrl(env),
  {
    method: 'GET',
    timeout: TIMEOUT,
    query: {
      projectid: projectId,
      size,
      include,
      sort,
      order,
      filter,
    },
  },
);

/**
 * 运行时：申请 MCP Key（"权限和密钥"弹窗使用）
 * POST /api/xy/runtime/env/{env}/mcp-key/apply
 */
const createMcpKeyRuntime = async ({ projectId, env, data = {} }) => await wujiFetch(
  `${getMcpKeyRuntimeBaseUrl(env)}/apply?projectid=${projectId}`,
  {
    method: 'POST',
    timeout: TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      metadata: data.metadata || '',
    }),
  },
);

export {
  listMcpKey,
  createMcpKey,
  deleteMcpKey,
  updateMcpKey,
  listMcpKeyRuntime,
  createMcpKeyRuntime,
};
